export const environment = {
  DEVELOPMENT: "DEVELOPMENT",
  QA: "QA",
  STAGING: "STAGING",
  PRODUCTION: "PRODUCTION",
};

export const environmentTest = {
  DEVELOPMENT: "DEVELOPMENT",
  QA: "QA",
  STAGING: "STAGING",
  PRODUCTION: "PRODUCTION",
};

export const DomainEnum = {
  PDFSIMPLI: "pdfsimpli",
  SIGNSIMPLI: "signsimpli",
  RESUMEBUILD: "resumebuild",
  LEGALSIMPLI: "legalsimpli",
  WORKSIMPLI: "worksimpli",
};

//export default environment;
